// extracted by mini-css-extract-plugin
export default {"hosted":"style_hosted__6C8Rz","content":"style_content__uLDxz"};